var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{staticStyle:{"width":"68px","height":"68px","border":"none","background":"transparent"},attrs:{"bottom":100,"visibility-height":50}},[_c('el-button',{staticClass:"el-icon-up",attrs:{"id":"up_btn"},on:{"click":function($event){return _vm.backtopbtn()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }